import { forwardRef } from "react";

import { cn } from "@/ui/lib/utils";
import {
  SECTION_DEFAULTS,
  TSectionProps,
} from "@/ui/components/layout/Section";

export const Section = forwardRef<HTMLElement, TSectionProps>(
  (
    {
      "data-component": component = SECTION_DEFAULTS["data-component"],
      className,
      children,
      ...props
    },
    ref,
  ) => {

    return (
      <section
        {...props}
        ref={ref}
        data-component={component}
        className={cn(
          "w-full",
          className,
        )}
      >
        { children }
      </section>
    );
  },
);

Section.displayName = "Section";
